export function getSafeAppPath(value: string | null | undefined, fallback = '/home'): string {
  const candidate = value?.trim() || fallback;

  if (!candidate.startsWith('/')) {
    return fallback;
  }

  try {
    const url = new URL(candidate, 'https://image2video.local');
    if (url.origin !== 'https://image2video.local') {
      return fallback;
    }

    return `${url.pathname}${url.search}${url.hash}` || fallback;
  } catch {
    return fallback;
  }
}
